/**
 * Small mobile-only chrome shared by the chat-layout pages (chat + projects):
 * the topbar hamburger that opens the sidebar drawer, and the backdrop that
 * closes it. Both are pure presentational; the open/close state lives in
 * `useMobileNav`. Callers gate rendering on `isMobile` (and `mobileNavOpen` for
 * the backdrop) so neither exists in the desktop DOM.
 */

interface ToggleProps {
  onOpen: () => void;
}

/** Top-left hamburger button (rendered into the topbar). */
export function MobileNavToggle({ onOpen }: ToggleProps) {
  return (
    <button
      type="button"
      className="topbar-icon-btn mobile-nav-btn"
      onClick={onOpen}
      title="Open menu"
      aria-label="Open menu"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="3" y1="18" x2="21" y2="18" />
      </svg>
    </button>
  );
}

interface BackdropProps {
  onClose: () => void;
}

/** Dimmed backdrop behind the open drawer; tap to close. */
export function SidebarBackdrop({ onClose }: BackdropProps) {
  return (
    <button
      type="button"
      className="sidebar-backdrop"
      aria-label="Close menu"
      onClick={onClose}
    />
  );
}
